/**
 * This is where app-wide constants should be, so that there are no magic numbers in code.
 * Don't use this class for environment configurations and integration, that's where config module comes in play.
 */
export class Globals {

    /**
     * First page number.
     */
    public static firstPage = 0;

    /**
        Values used to determine how many items we want on a single page.
     */
    public static itemsPerPage = {
        /**
         * Unified value, that is widely used in many components.
         */
        common: 4,
        /**
         * Value used in history request table.
         */
        historyRequests: 10
    };

    /**
     * Typeahead constants reused among application, card and service provider (history requests application and cards).
     */
    public static typeahead = {
        /**
         * Debounce time used for suggest / typeahead. Time delay that reduces server calls.
         * @type {number} milliseconds
         */
        debounceTime: 300,

        /**
         * Min letters typed by a user to start typeahead / fetch suggested items.
         */
        minLetters: 2,

        /**
         * Suggested items limit - count of suggested items displayed.
         */
        optionsLimit: 100,
        /**
         * Maximum number of options shown at any time in the box. The rest is accessible via scrollbar.
         */
        scrollableViewSize: 6
    };

    /**
     * This server for cross-validation of 3 related fields (App/Card name, Account number, Request type)
     * on history request page.
     */
    public static conflictRequestTypeIds = {
        /**
         * Describes conflict Ids of request types, when any account is selected.
         */
        forAccounts: ['2', '6', '7', '8', '9', '10', '11'],
        /**
         * Describes conflict Ids of request types, when App or Card name is written.
         */
        forName: ['11', '15', '17']
    };
    /**
     * Calendar picker constants.
     */
    public static calendarPicker = {
        /**
         * The minimum date the calendar picked is allowed to select.
         */
        minDate: '01/01/1970'
    };

    /**
     * Request type ids used for checking if to show NIA tile or not.
     */
    public static niaCheckRequestTypes = '15,17';

    public static bankidRequestTypes = '15,16,17,18,21';

    public static psd2RequestTypes = '1,2,3,4,5,6,7,8,11,12,13,14,19,20,22,23,24';

    /**
     * Idle timeout values to automatical logout
     */
    public static idleLogout = {
        /*
         * sets an idle timeout.
         */
        idle: 270,
        /*
         * sets a timeout period after idle+timeout seconds of inactivity, the user will be logged out.
         */
        timeout: 30,
        /*
         * sets the ping interval to 15 seconds
         */
        ping: 10
    };

    /**
     * Role to chceck for using BankID consent toggle button from CPS
     */
    public static roleSspAutenticationUsersRW = 'SSP_Autentication_Users_RW';
    public static georgeBusinessClientId = 'urn:csas:apps:george_business';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.globals.ts